import { gql, graphQueryBang } from "shared/lib/graphql"
import { serviceMapper, appletMapper } from "./gql_data_mapper"

const AllAppletMetricsQuery = gql`
  query(
    $service: String!
    $metric_start_date: DataServiceDate!
    $metric_end_date: DataServiceDate!
  ) {
    channel(module_name: $service) {
      total_applet_likes
      total_applet_dislikes
      total_applet_opinion_codes {
        too_slow
        not_useful
        no_response
        unexpected
      }
    }
    service_metrics(
      channel_module_name: $service
      metric_start_date: $metric_start_date
      metric_end_date: $metric_end_date
    ) {
      metrics {
        metric_date
        applet_enables_daily
        applet_disables_daily
        applet_runs_daily
        unsuccessful_applet_runs_daily
      }
    }
  }
`
const SingleAppletMetricsQuery = gql`
  query(
    $slug: String!
    $metric_start_date: DataServiceDate!
    $metric_end_date: DataServiceDate!
  ) {
    normalized_applets(ids: [$slug]) {
      type
      service_slug
      by_service_owner
      permissions {
        id
      }
      applet_feedback_count {
        like
        dislike
      }
      applet_opinion_count {
        too_slow
        not_useful
        no_response
        unexpected
      }
      applet_metrics(
        metric_start_date: $metric_start_date
        metric_end_date: $metric_end_date
      ) {
        metric_date
        enables_daily
        disables_daily
        successful_runs_daily
        unsuccessful_runs_daily
      }
    }
  }
`

const composedQuery = (query, timePeriodMetric) =>
  query.replace(/TIME_PERIOD/g, timePeriodMetric)

export default function appletMetricsFetcher(
  serviceModuleName,
  _,
  __,
  { dailyMetricStartDate, currentMetricDate, timePeriodMetric, appletSlug }
) {
  const variables = {
    service: serviceModuleName,
    slug: appletSlug,
    metric_start_date: dailyMetricStartDate,
    metric_end_date: currentMetricDate,
  }
  const query = appletSlug ? SingleAppletMetricsQuery : AllAppletMetricsQuery
  const dataMapper = appletSlug ? appletMapper : serviceMapper
  return graphQueryBang(
    composedQuery(query, timePeriodMetric),
    variables
  ).then(data =>
    dataMapper(data, timePeriodMetric, appletSlug, serviceModuleName)
  )
}
